import { GET_ALL_OFFERS_BY_ID } from "../constants";
import { RequestService } from "../../../../../common/services/RequestService";
import {
  adjustRequestData,
  dataAdjustmentGetAllOffersRequest
} from "./adjustAllOffers";

export const getAllOffers = async (
  profileId,
  payload = {
    limit: 5,
    page: 1
  }
) => {
  const response = await RequestService.get(GET_ALL_OFFERS_BY_ID + profileId, {
    params: dataAdjustmentGetAllOffersRequest(payload)
  });
  return {
    pagination: {
      ...response.data.meta
    },
    data:
      response.data.data &&
      response.data.data.map(offer => adjustRequestData(offer))
  };
};
